module.exports = __webpack_public_path__ + "img/_ico.1117cfbc.svg";